function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
export var GalleryContext;

try {
  GalleryContext = React.createContext({});
} catch (e) {
  GalleryContext = null;
}

var GALLERY_CONTEXT_FIELDS = ['isUnknownWidth'];
export var extractContextFields = function extractContextFields(fields) {
  return GALLERY_CONTEXT_FIELDS.reduce(function (obj, field) {
    obj[field] = fields[field];
    return obj;
  }, {});
};
export var GalleryProvider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GalleryProvider, _React$Component);

  function GalleryProvider(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = extractContextFields(props);
    return _this;
  }

  var _proto = GalleryProvider.prototype;

  _proto.render = function render() {
    if (GalleryContext) {
      // const value = { ...this.value, ...this.state };
      return /*#__PURE__*/React.createElement(GalleryContext.Provider, {
        value: this.state
      }, this.props.children);
    } else {
      return this.props.children;
    }
  };

  return GalleryProvider;
}(React.Component);